import React, { useEffect, useState } from 'react'
import Filter from "../../../../assets/Icons/filter.png";
import Download from "../../../../assets/Icons/Download_Icon.png";
import PDF from "../../../../assets/Icons/Pdf_Icon.png";
import { useRef } from "react";
import { useDownloadExcel } from "react-export-table-to-excel";
import leftArrow from "../../../../assets/Images/left-arrow.png";
import rightArrow from "../../../../assets/Images/right-arrow.png";
import "../saftey.css"
import { DPR_API } from '../../../../services/apiCalls/dprApiCalls';
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import Close from "../../../../assets/Images/close.png";
import { dateFormate } from '../../../../services/_helpers/dateFormate';
import ExcelExport from '../../../../compnenets/commons/xls';
import { sortArray } from '../../../../services/_helpers/sorting';


export default function ObservationList(props) {
     const tableRef = useRef(null);
     const [openFilter, setOpenFilter] = useState(false);
     const [observationList, setObservationList] = useState([]);
    const onCloseFilter = () => setOpenFilter(true);
      const [sortOrder, setShortOrder] = useState("asc");
      const [sortOrderType, setShortOrderType] = useState("");

    const [filterData, setFilterData] = useState({
      "StartDate": null,        
      "EndDate": null,
      "LOID": null,
      "DateOfObservation": null ,
      "DateOfVisit":null,
      "ObservationStatus": null
      });
      const sortData=[
        {name:"Date of Visit",value:"DateOfVisit"},
        {name:"Severity level",value:"SeverityLevel"},
        // {name:"Created date",value:""},
        // {name:"Baseline End",value:""},
        {name:"Employee ID",value:"EmployeeID"},
        {name:"Date Of Observation",value:"DateOfObservation"},
      ]
    const { onDownload } = useDownloadExcel({
        currentTableRef: tableRef.current,
        filename: "machinery resources",
        sheet: "Machinry",
      });

      const handleChange = (event) => {
        const { name, value } = event.target;
        setFilterData((prev) => ({ ...prev, [name]: value }));
      };

      const getGet_observationData=async()=>{
        dateFormate(filterData?.StartDate);
        dateFormate(filterData?.EndDate);
        let data=filterData;
        data["StartDate"]=filterData?.StartDate?dateFormate(filterData?.StartDate):null;
        data["EndDate"]=filterData?.StartDate?dateFormate(filterData?.EndDate):null;
        const obs=await DPR_API.getObservation(data);
        if(obs && obs?.Observation?.length){
          setObservationList(obs?.Observation) 
        }else{
          setObservationList([])
        }
  
           }
           useEffect(()=>{
            getGet_observationData();
           },[])
           const handleFilterClick = async () => {
            const obs=await DPR_API.getObservation(filterData);
            if(obs && obs?.Observation?.length){
              if(sortOrderType==""){
                setObservationList(obs?.Observation) 
              }else{
                const sortData=sortArray(obs?.Observation,sortOrderType,"string",sortOrder);
                setObservationList(sortData)
              }
            }else{
              setObservationList([])
            }
            setOpenFilter(false);
          };
        
          const handleClear=async()=>{
            let data={
              "StartDate": null,        
              "EndDate": null,
              "LOID": null,
              "DateOfObservation": null,
              "DateOfVisit":null,
              "ObservationStatus": null
            };
            setCurrentPage(1)
            setFilterData(data);
            const obs=await DPR_API.getObservation(data);
            if(obs && obs?.Observation?.length){
              setObservationList(obs?.Observation) 
            }else{
              setObservationList([])
            }
          }
      const [currentPage, setCurrentPage] = useState(1);
        const rowsPerPage = 10;
      
        const totalPages = Math.ceil(observationList.length / rowsPerPage);
      
        const handleClick = (page) => {
          setCurrentPage(page);
        };
      
        const paginatedData = observationList.slice(
          (currentPage - 1) * rowsPerPage,
          currentPage * rowsPerPage
        );


  function truncateFileNameFromPath(fileName, maxLength) {
    const dotIndex = fileName.lastIndexOf(".");
    if (dotIndex === -1) {
      return fileName;
    }

    const name = fileName.substring(0, dotIndex);
    const extension = fileName.substring(dotIndex);

    if (fileName.length > maxLength) {
      const visibleLength = maxLength - 1 - extension.length;
      const startLength = Math.ceil(visibleLength / 2);
      const endLength = Math.floor(visibleLength / 2);
      const truncatedName = `${name.substring(
        0,
        startLength
      )}...${name.substring(name.length - endLength)}`;
      return `${truncatedName}${extension}`;
    }

    return fileName;
  }

  useEffect(()=>{
    props.setUpdateDate(null)
  },[])
  return<React.Fragment>
     <div className="row">
        <div className="d-flex justify-content-end">
          <div className="download-icon">
          <ExcelExport
              data={observationList}
              fileName="Log observation"
              sheet="Log observation"
            />
          </div>
          <div className="filter-icon mx-2 my-auto">
            <img
              className=""
              onClick={() => {
                setOpenFilter(true);
              }}
              src={Filter}
              width={20}
            />
          </div>
          <div className="my-auto">
              <span style={{ cursor: "pointer", fontSize: 12, fontWeight: 500, background: "#8add79f7", padding: 5, borderRadius: 12 }} onClick={handleClear}>Clear filters</span>
            </div>
        </div>
      </div>
      <div className="table-container">
            <table id="custom-table-archival">
                <thead className="table-header-archival">
            <tr>
              <th>S.No</th>
              <th>Name</th>
              <th>LO ID</th>
              <th>Employee ID</th>
              <th>Created Date</th>
              <th>Date of Visit</th>
              <th>Date of observation</th>
              <th>Project Name</th>
              <th>Location</th>
              <th>Status</th>
              <th>Compliance Evidence</th>
            </tr>
          </thead>
          <tbody>
            {paginatedData.map((row, index) => (
              <tr key={index} onClick={()=>{
                props.setUpdateDate(row)
                props?.setSelectedIndex(1)
              }}>
                <td>{index+1}</td>
                
                <td
                  style={{
                    color: "rgb(102 104 106)",
                    fontSize: 14,
                    fontWeight: 500,
                  }}
                >
                 {row?.Name}
                </td>
                <td
                  style={{
                    color: "rgb(102 104 106)",
                    fontSize: 14,
                    fontWeight: 500,
                  }}
                >
                  {row?.LOID}
                </td>
                <td
                  style={{
                    color: "rgb(102 104 106)",
                    fontSize: 14,
                    fontWeight: 500,
                  }}
                >
                 {row?.EmployeeID}
                </td>
                <td
                  style={{
                    color: "rgb(102 104 106)",
                    fontSize: 14,
                    fontWeight: 500,
                  }}
                >   
               {dateFormate(row?.CreatedOn,"DD/MM/YYYY")}
                </td>
                <td
                  style={{
                    color: "rgb(102 104 106)",
                    fontSize: 14,
                    fontWeight: 500,
                  }}
                >   
               {dateFormate(row?.DateOfVisit,"DD/MM/YYYY")}
                </td>
               
                <td
                  style={{
                    color: "rgb(102 104 106)",
                    fontSize: 14,
                    fontWeight: 500,
                  }}
                >
                {dateFormate(row?.DateOfObservation,"DD/MM/YYYY")}
                </td>
                <td
                  style={{
                    color: "rgb(102 104 106)",
                    fontSize: 14,
                    fontWeight: 500,
                  }}
                >
                 {row?.ProjectName}
                </td>
                <td>{row?.SiteNameLocation}</td>
                <td>{row?.ObservationStatus}</td>
                <td
                  style={{
                    color: "rgb(102 104 106)",
                    fontSize: 14,
                    fontWeight: 500,
                  }}
                >
                  <div className='d-flex justify-content-between'>
                  <div>
                    <img src={PDF} width={12}/>
                  </div>
                  <div className='my-auto'>
                  {truncateFileNameFromPath(
                        decodeURIComponent(row?.ComplianceEvidence?.split("/").pop()),
                        12
                      )}
                {/* {row?.ComplianceEvidence} */}
                  </div>
                  <div>
                  <img src={Download} width={12} style={{cursor:"pointer"}}
                  onClick={()=>{
                    const link = document.createElement("a");
                    link.href = row?.ComplianceEvidence;
                    console.log(row?.ComplianceEvidence?.split("/").pop());
                    link.setAttribute("download", row?.ComplianceEvidence?.split("/").pop());
                    // link.download = decodeURIComponent(fileUrl?.split('/').pop());
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                  }}
                  />
                  </div>
                  </div>
                </td>
                
              </tr>
            ))}
          </tbody>
        </table>
      </div>
        <div
          className="pagination"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "10px 15px",
          }}
        >
          <div style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
            Showing{" "}
            {Math.min((currentPage - 1) * rowsPerPage + 1, observationList.length)} to{" "}
            {Math.min(currentPage * rowsPerPage, observationList.length)} of{" "}
            {observationList.length} entries
          </div>

          <div
            className="pagination-buttons"
            style={{
              fontSize: "14px",
              display: "flex",
              justifyContent: "flex-end",
              width: "100%",
              gap: "5px",
            }}
          >
            {/* Left Arrow */}
            <button
              onClick={() => handleClick(Math.max(1, currentPage - 1))}
              disabled={currentPage === 1}
              style={{
                background: "none",
                border: "none",
                cursor: currentPage === 1 ? "not-allowed" : "pointer",
              }}
            >
              <img
                src={leftArrow} // Replace with your actual image path
                alt="Previous"
                height="11px"
                width="7px"
                style={{ opacity: currentPage === 1 ? 0.5 : 1 }}
              />
            </button>

            {/* Page Numbers */}
            {[...Array(totalPages)].map((_, i) => (
              <button
                key={i}
                onClick={() => handleClick(i + 1)}
                style={{
                  background: currentPage === i + 1 ? "#00B69B" : "transparent",
                  color: currentPage === i + 1 ? "#fff" : "#000",
                  border: "none",
                  borderRadius: "50%",
                  width: "30px",
                  height: "30px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                }}
              >
                {i + 1}
              </button>
            ))}

            {/* Right Arrow */}
            <button
              onClick={() => handleClick(Math.min(totalPages, currentPage + 1))}
              disabled={currentPage === totalPages}
              style={{
                background: "none",
                border: "none",
                cursor: currentPage === totalPages ? "not-allowed" : "pointer",
              }}
            >
              <img
                src={rightArrow} // Replace with your actual image path
                alt="Next"
                height="11px"
                width="7px"
                style={{ opacity: currentPage === totalPages ? 0.5 : 1 }}
              />
            </button>
          </div>
        </div>
        <Modal open={openFilter} onClose={onCloseFilter} center>
        <div className="d-flex justify-content-between">
          <div>
            <span className="resources">Log Observation Filter</span>
          </div>
          <div>
            <img
              src={Close}
              width={20}
              onClick={() => setOpenFilter(false)}
              style={{ cursor: "pointer" }}
            />
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="card mt-0 card-bd-none">
            <div className="card-body">
               <div className="row mt-1">
                <div className="col-6">
                  <label className="filter-label">Start Date</label>
                  <input
                    type="date"
                    name="StartDate"
                    value={filterData.StartDate}
                    onChange={handleChange}
                    className="form-control shadow-none"
                  />
                </div>
                <div className="col-6">
                  <label className="filter-label">End Date</label>
                  <input
                    type="date"
                    name="EndDate"
                    value={filterData.EndDate}
                    onChange={handleChange}
                    className="form-control shadow-none"
                  />
                </div>
              </div>

              <div className="row mt-1">
                <div className="col-6">
                  <label className="filter-label">Date Of Observation</label>
                  <input
                    type="date"
                    name="DateOfObservation"
                    value={filterData.DateOfObservation}
                    onChange={handleChange}
                    className="form-control shadow-none"
                  />
                </div>
                <div className="col-6">
                  <label className="filter-label">Date of Visit</label>
                  <input
                    type="date"
                    name="DateOfVisit"
                    value={filterData.DateOfVisit}
                    onChange={handleChange}
                    className="form-control shadow-none"
                  />
                </div>
              </div>

              <div className="row mt-1">
                <div className="col-6">
                  <label className="filter-label">LO ID</label>
                  <input
                    type="text"
                    name="LOID"
                    value={filterData.LOID}
                    onChange={handleChange}
                    className="form-control shadow-none"
                  />
                </div>
                <div className="col-6">
                  <label className="filter-label">Observation Status</label>
                  <input
                    type="text"
                    name="location"
                    value={filterData.location}
                    onChange={handleChange}
                    className="form-control shadow-none"
                  />
                </div>
              </div>

            </div>
          </div>
        </div>
        <div className="row">
          <div className="d-flex justify-content-between">
            <div style={{ marginLeft: 20 }}>
              <span className="resorces">Sort Log Observation</span>
            </div>
            <div style={{ marginRight: 20 }}>
              <select
                name="sortOrder"
                value={sortOrder}
                 onChange={(e)=>{
                setShortOrder(e.target.value)
              }}
                className="filter-label"
                style={{
                  width: "100%",
                  height: 31,
                  border: "1px solid #e6e3e3",
                  borderRadius: 4,
                }}
              >
                <option value="asc">ASC</option>
                <option value="desc">DES</option>
              </select>
            </div>
          </div>
        </div>
        <div className="row" style={{ marginLeft: 20 }}>
          {sortData.map((sortOption) => (
            <div className="form-check" key={sortOption}>
              <input
                className="form-check-input shadow-none"
                type="radio"
                name="sortBy"
                id={sortOption?.name}
                value={sortOption?.value}
                checked={sortOrderType==sortOption?.value}
                 onChange={(e)=>{
                setShortOrderType(sortOption?.value)
              }}
              />
              <label htmlFor={sortOption?.name} style={{ fontSize: 14 }}>
                {sortOption?.name}
              </label>
            </div>
          ))}
        </div>

        <div className="d-flex justify-content-center mt-4 pb-4">
          <button
            className="btn btn-primary"
            onClick={handleFilterClick}
          >
            Filter
          </button>
        </div>
      </Modal>
  </React.Fragment>
}
